var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#0E477A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.084 6.83203H13.2507C8.66732 6.83203 6.83398 8.66536 6.83398 13.2487V18.7487C6.83398 23.332 8.66732 25.1654 13.2507 25.1654H18.7507C23.334 25.1654 25.1673 23.332 25.1673 18.7487V16.9154",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7027 7.76686L12.4794 14.9902C12.2044 15.2652 11.9294 15.806 11.8744 16.2002L11.4802 18.9594C11.3336 19.9585 12.0394 20.6552 13.0386 20.5177L15.7977 20.1235C16.1827 20.0685 16.7236 19.7935 17.0077 19.5185L24.2311 12.2952C25.4777 11.0485 26.0644 9.60019 24.2311 7.76686C22.3977 5.93352 20.9494 6.52019 19.7027 7.76686Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.668 8.80469C19.2821 10.9955 20.9963 12.7097 23.1963 13.333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/Rename.968233f97535caaf3bf08b5b5c8fd29d.svg";
export { ForwardRef as ReactComponent };